/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shopping_Back_On_ListInputs */

const en_shopping_back_on_list = /** @type {(inputs: Shopping_Back_On_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Put ${i?.name} back on the list`)
};

const de_shopping_back_on_list = /** @type {(inputs: Shopping_Back_On_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wieder auf die Liste`)
};

/**
* | output |
* | --- |
* | "Put {name} back on the list" |
*
* @param {Shopping_Back_On_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_back_on_list = /** @type {((inputs: Shopping_Back_On_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Back_On_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_back_on_list(inputs)
	return en_shopping_back_on_list(inputs)
});